// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging"; // ✅ Import FCM
import { getFunctions } from "firebase/functions"; // ✅ Import Functions

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyANHMyJgcE9zNKmwxNh6rJHzxFlXN2LIfU",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "jr-homemade-foods.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "jr-homemade-foods",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "jr-homemade-foods.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "73546787945",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:73546787945:web:56bde64aac540473cec6f8"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const messaging = getMessaging(app); // ✅ Export messaging
export const functions = getFunctions(app); // ✅ Export functions

// 🔐 VAPID Key for Web Push Notifications
export const VAPID_KEY = "BCZSCigkuHTBWDzlKw2FoVOGXzRG-bHKMJXP322BOOz1vLFD31cmIQgUGgqUAdyJSpCWs2OiOmtkuVnQBDKFREc";

// 🗺️ Google Maps API Key
export const GOOGLE_MAPS_API_KEY = "AIzaSyBnWSiMg6PDeqo8Rij0i8_YpMBqGXIl7QQ";
